// extracted by mini-css-extract-plugin
module.exports = {"SearchResult":"SearchView_SearchResult__fwjnK"};